var map = {
	"./blog.png": 20407,
	"./case_study.png": 26741,
	"./documentary.png": 69076,
	"./how_to_guide.png": 76976,
	"./lecture.png": 31141,
	"./podcast.png": 61303,
	"./policy.png": 45797,
	"./practitioner.png": 36515,
	"./report.png": 88317,
	"./research_study.png": 58546,
	"./slide_presentation.png": 38269,
	"./template.png": 75541,
	"./toolkit.png": 62905,
	"./training.png": 21369,
	"./video.png": 84290,
	"./web_article.png": 84778,
	"assets/images/catalog/blog.png": 20407,
	"assets/images/catalog/case_study.png": 26741,
	"assets/images/catalog/documentary.png": 69076,
	"assets/images/catalog/how_to_guide.png": 76976,
	"assets/images/catalog/lecture.png": 31141,
	"assets/images/catalog/podcast.png": 61303,
	"assets/images/catalog/policy.png": 45797,
	"assets/images/catalog/practitioner.png": 36515,
	"assets/images/catalog/report.png": 88317,
	"assets/images/catalog/research_study.png": 58546,
	"assets/images/catalog/slide_presentation.png": 38269,
	"assets/images/catalog/template.png": 75541,
	"assets/images/catalog/toolkit.png": 62905,
	"assets/images/catalog/training.png": 21369,
	"assets/images/catalog/video.png": 84290,
	"assets/images/catalog/web_article.png": 84778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78252;